export class PackageManager {
  /**
   * @type {Object}
   */
  _packages;

  constructor() {
    this._packages = {};
  }

  /**
   * Add a new package to the package manager
   * @param pkg
   */
  registerPackage(pkg) {
    /*
     * Make sure the package has a namespace
     */
    if (!pkg.hasOwnProperty("namespace")) {
      throw new Error("Package must have a namespace property.");
    }

    /*
     * Make sure a package with that namespace does not already exist
     */
    if (this.packageExists(pkg.namespace)) {
      throw new Error(
        "A package with the namespace %s already exists.".replace(
          "%s",
          pkg.namespace
        )
      );
    }

    /*
     * Register the package
     */
    this._packages[pkg.namespace] = pkg;
  }

  /**
   * Checks to see if a package has been registered
   * @param pkgNamespace {string} The namespace of the package to check
   * @returns {boolean}
   */
  packageExists(pkgNamespace) {
    return this._packages.hasOwnProperty(pkgNamespace);
  }

  /**
   * Validates the packages to make sure all required packages has been registered.
   * @returns {boolean}
   */
  isValid() {
    //todo: Loop through all packages and make sure that all required packages are registered.
  }

  /**
   * An Install method to register packages with Vue
   * @param Vue
   */
  install(Vue) {
    let packages = this._sortedPackageArray();
    for (let i in packages) {
      if (packages.hasOwnProperty(i)) {
        let pkg = packages[i];

        /*
         * Check to see if the package has an install function,
         * if so tell vue to "use" it.
         */
        if (
          pkg.hasOwnProperty("install") &&
          typeof pkg.install === "function"
        ) {
          Vue.use(pkg);
        }
      }
    }
  }

  /**
   * Loop through all packages and run their init script
   * @param kernel {Kernel}
   */
  preload(kernel) {
    let packages = this._sortedPackageArray();
    for (let i in packages) {
      if (packages.hasOwnProperty(i)) {
        let pkg = packages[i];
        this._parseLocale(kernel, pkg);
      }
    }
  }

  /**
   * Loop through all packages and run their init script
   * @param kernel {Kernel}
   */
  initializePackages(kernel) {
    let packages = this._sortedPackageArray();
    for (let i in packages) {
      if (packages.hasOwnProperty(i)) {
        let pkg = packages[i];

        /*
         * Check to see if the package has an install function,
         * if so tell vue to "use" it.
         */
        if (pkg.hasOwnProperty("init") && typeof pkg.init === "function") {
          pkg.init(kernel);
        }
      }
    }
  }

  /**
   * Parse a package config for Locale content and add it to the master Locale library.
   * @param kernel {Kernel}
   * @param pkg {Object}
   * @private
   */
  _parseLocale(kernel, pkg) {
    if (
      pkg.hasOwnProperty("locale") &&
      pkg.locale != null &&
      Object.keys(pkg.locale).length > 0
    ) {
    }
  }

  /**
   * Get a list of packages sorted by their required load order.
   * @returns {[]}
   * @private
   */
  _sortedPackageArray() {
    let unsortedPackages = [];
    let sortedPackages = [];

    /*
     * Build an array of unsorted and sorted packages.
     */
    for (let i in this._packages) {
      if (this._packages.hasOwnProperty(i)) {
        if (
          !this._packages[i].hasOwnProperty("requires") ||
          (Array.isArray(this._packages[i]) && this._packages[i].length <= 0)
        ) {
          sortedPackages.push(this._packages[i]);
        } else {
          unsortedPackages.push(this._packages[i]);
        }
      }
    }
    for (let i in unsortedPackages) {
      if (unsortedPackages.hasOwnProperty(i)) {
        sortedPackages.push(unsortedPackages[i]);
      }
    }
    return sortedPackages;
  }
}
